import type { RouterOutputs } from "@repo/api";

import { IntegrationContext } from "~/hooks/use-integration";
import { api } from "~/lib/api";

export type Integration =
  RouterOutputs["integration"]["getIntegrations"][number];
export type UserIntegration =
  RouterOutputs["integration"]["getUserIntegrations"][number];

export function IntegrationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: integrations } = api.integration.getIntegrations.useQuery();
  const { data: userIntegrations } =
    api.integration.getUserIntegrations.useQuery();

  if (!integrations || !userIntegrations) {
    return null;
  }

  const context = {
    integrations,
    userIntegrations,
  };

  return (
    <IntegrationContext.Provider value={context}>
      {children}
    </IntegrationContext.Provider>
  );
}
